import React from 'react';
import { motion } from 'framer-motion';
import { BookOpen, Gift, CheckCircle } from 'lucide-react';
const deliverables = [{
  title: 'Ebook Principal: El Código Metabólico Latino',
  desc: 'El paso a paso para dominar tu glucosa.',
  value: 97,
  icon: BookOpen,
  isMain: true
}, {
  title: 'BONUS 1: Recetario Mexicano "México Lindo y Saludable"',
  desc: 'Tacos, Pozole y Chilaquiles optimizados para tu salud.',
  value: 37,
  icon: Gift
}, {
  title: 'BONUS 2: Protocolo de Fiestas y Salidas',
  desc: 'Cómo disfrutar bautizos y bodas sin picos de azúcar.',
  value: 27,
  icon: Gift
}, {
  title: 'BONUS 3: Guía Walmart & Aldi',
  desc: 'Las marcas exactas que NO inflaman tu cuerpo.',
  value: 47,
  icon: Gift
}, {
  title: 'BONUS 4: El Mapa de Infusiones de la Abuela',
  desc: 'Tés poderosos que bajan el azúcar naturalmente.',
  value: 27,
  icon: Gift
}, {
  title: 'BONUS 5: Hoja de Trucos "Cheat Sheet"',
  desc: 'Las 5 reglas de oro para pegar en tu refrigerador.',
  value: 17,
  icon: Gift
}];
export function Offer() {
  return <section id="oferta" className="py-20 bg-cream" data-id="element-107">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-108">
        <div className="text-center mb-12" data-id="element-109">
          <h2 className="text-3xl md:text-5xl font-bold text-forest-dark mb-4" data-id="element-110">
            Presentamos: <br className="md:hidden" data-id="element-111" />
            <span className="text-gold" data-id="element-112">EL CÓDIGO METABÓLICO LATINO</span>
          </h2>
          <p className="text-lg md:text-xl text-gray-600 max-w-2xl mx-auto" data-id="element-113">
            El sistema completo que te enseña a navegar Walmart como un experto
            y a comer en fiestas latinas sin miedo.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-start" data-id="element-114">
          <div className="lg:col-span-5 flex justify-center lg:sticky lg:top-24" data-id="element-115">
            <motion.img initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} src="https://cdn.magicpatterns.com/uploads/gY9h1YT9DpGdvKgaQX23EG/cover_codigo_metabokico_latino.png" alt="El Código Metabólico Latino Bundle" className="w-full max-w-md rounded-2xl shadow-2xl" data-id="element-116" />
          </div>

          <div className="lg:col-span-7" data-id="element-117">
            <h3 className="text-2xl font-bold text-forest mb-6" data-id="element-118">
              Esto es lo que te llevas hoy:
            </h3>

            <div className="space-y-4" data-id="element-119">
              {deliverables.map((item, index) => <motion.div key={index} initial={{
              opacity: 0,
              x: 20
            }} whileInView={{
              opacity: 1,
              x: 0
            }} viewport={{
              once: true
            }} transition={{
              delay: index * 0.1
            }} className={`p-4 md:p-5 rounded-xl border flex items-start ${item.isMain ? 'bg-forest text-white border-forest-light shadow-md' : 'bg-white text-gray-800 border-gray-200 shadow-sm'}`} data-id="element-120">
                  <div className={`p-2 rounded-lg mr-4 flex-shrink-0 ${item.isMain ? 'bg-gold/20' : 'bg-cream'}`} data-id="element-121">
                    <item.icon className={`w-6 h-6 ${item.isMain ? 'text-gold' : 'text-forest'}`} data-id="element-122" />
                  </div>
                  <div className="flex-grow" data-id="element-123">
                    <h4 className={`font-bold text-lg ${item.isMain ? 'text-gold' : 'text-forest-dark'}`} data-id="element-124">
                      {item.title}
                    </h4>
                    <p className={`text-sm mt-1 ${item.isMain ? 'text-cream-dark' : 'text-gray-600'}`} data-id="element-125">
                      {item.desc}
                    </p>
                  </div>
                  <div className="flex-shrink-0 ml-4 text-right" data-id="element-126">
                    <span className={`text-sm font-bold line-through opacity-60 ${item.isMain ? 'text-cream' : 'text-gray-400'}`} data-id="element-127">
                      ${item.value}
                    </span>
                  </div>
                </motion.div>)}
            </div>

            <div className="mt-8 p-6 bg-gray-100 rounded-xl border border-gray-200 flex justify-between items-center" data-id="element-128">
              <span className="text-xl font-bold text-gray-600" data-id="element-129">
                VALOR TOTAL:
              </span>
              <span className="text-3xl font-bold text-alert line-through decoration-alert/50 decoration-4" data-id="element-130">
                $252.00
              </span>
            </div>
          </div>
        </div>
      </div>
    </section>;
}